module.exports = __webpack_public_path__ + "img/SAGaming.89696636.png";